_collow.components.HintsExplanations = class HintsExplanations extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.removeExplanations();

    if (elements.hintContainer)
      this.listen(elements.hint, "click", () => {
        elements.hintContainer.toggleAttribute("hidden");
      });

    this.listen(
      document,
      `_collow.hint-${this.params.index}`,
      this.showExplanations
    );
  }

  /** set explanations based on answer */
  showExplanations = (event) => {
    if (this.elements.hint) {
      this.elements.hint.setAttribute("hidden", "");
    }
    
    if (this.elements.hintContainer) {
      this.elements.hintContainer.setAttribute("hidden", "");
    }

    if (event.detail && this.explanationCorrectHTML && this.elements.explanationCorrect) {
      this.elements.explanationCorrect.innerHTML = this.explanationCorrectHTML;
    }
    
    if (!event.detail && this.explanationWrongHTML && this.elements.explanationWrong) {
      this.elements.explanationWrong.innerHTML = this.explanationWrongHTML;
    }
  };

  /** remove data from the element */
  removeExplanations = () => {
    this.explanationCorrectHTML =
      this.elements?.explanationCorrect?.innerHTML ?? "";
    this.explanationWrongHTML = 
      this.elements?.explanationWrong?.innerHTML ?? "";
    
    if (this.elements.explanationCorrect) {
      this.elements.explanationCorrect.innerHTML = "";
    }
    
    if (this.elements.explanationWrong) {
      this.elements.explanationWrong.innerHTML = "";
    }
  };
};
